import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { useUpdateOrderDeliveryModal } from "../hooks/useUpdateOrderDeliveryModal";
import { DialogComponent } from "./DialogComponent";
/**
 * The update order delivery modal component. It is used to update the delivery address of an order.
 * This modal does not use the modal context normally used throughout the app.
 * @params
 * * currentOrderId: number;
 * * currentOrderInfo: IOrderInfo;
 * * currentOrderNumber: string;
 * * currentOrderStatus: Orders_SingleOrderInterface["OrderStatus"];
 * * flowSku?: string;
 * * initTabProps: InitTabProps;
 * * programId: number;
 * * refetchOrders: () => void;
 * * setShowModal: Dispatch<SetStateAction<boolean>>;
 * * showModal: boolean;
 * * subscriptionLinkId?: number;
 * * updateFunction: any; // FIXME
 * }
 * @returns
 */
export const UpdateOrderDeliveryModal = (props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const componentProps = useUpdateOrderDeliveryModal(props);
    const { showModal, onClose } = componentProps;
    return (_jsx(Dialog, Object.assign({ maxWidth: "md", fullScreen: isMobile, fullWidth: true, open: showModal, onClose: onClose }, { children: _jsx(DialogComponent, Object.assign({}, componentProps)) })));
};
